// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
// import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm"; // Starter Custom Code
import submitContactForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
// import React, { useState } from "react"; // Starter Custom Code
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
// import FormActions from "@store/Library/Components/Toolkit/FormActions"; // Greif Custom Code
import FormWrapper from "@store/Library/Components/Toolkit/FormWrapper";
// import FormActions from "@store/Library/Components/Toolkit/FormActions"; // Greif Custom Code
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import resetState from "@store/Framework/Store/Greif/Pages/ContactUs/Handlers/ResetState";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import constants from "@toolkit/Framework/Common/GoogleAnalytics/constants";
// import React, { useEffect, useRef, useState } from "react"; // Greif Custom Code
/* Starter Custom Code - End */

/* Greif Custom Code - Start */
import FormActions, { FormActionsProps } from "@store/Library/Components/Toolkit/FormActions";
import { useIsAuthenticated } from "@store/Framework/Store/Context/ContextHooks";
import clearGreifForm from "@store/Framework/Store/Greif/Pages/ContactUs/Handlers/ClearForm";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import React, { RefObject, useEffect, useMemo, useRef, useState } from "react";

const enum topicToHideFields {
    getStarted = "Get Started with Greif",
    other = "Other",
}

export const topicToHideFieldsArray: string[] = [topicToHideFields.getStarted, topicToHideFields.other, ""];
/* Greif Custom Code - End */

const enum fields {
    emailRecipients = "emailRecipients",
    submitButtonText = "submitButtonText",
    successMessage = "successMessage",
    // Greif Custom Code
    continueLink = "continueLink",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.emailRecipients]: string;
        [fields.submitButtonText]: string;
        [fields.successMessage]: string;
        // Greif Custom Code
        [fields.continueLink]: string;
    };
}

const mapDispatchToProps = {
    submitContactForm,
    clearForm,
    validateReCaptcha: makeHandlerChainAwaitable<{ location: string; recaptchaRef: RefObject<ReCAPTCHA> }, boolean>(
        validateReCaptcha,
    ),
    // Greif Custom Code
    setFieldValue,
    resetState,
    clearGreifForm,
};

const mapStateToProps = (state: ApplicationState) => ({
    /* Greif Custom Code - Start */
    session: getSession(state),
    topic: state.components.contactUsForm.fieldValues["topic"],
    /* Greif Custom Code - End */
});

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ContactFormStyles {
    container?: GridContainerProps;
    formGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    successModal?: ModalPresentationProps;
    modalContainer?: GridContainerProps;
    messageTextGridItem?: GridItemProps;
    messageText?: TypographyPresentationProps;
    buttonGridItem?: GridItemProps;
    continueButton?: ButtonPresentationProps;
    // Starter Custom Code
    successBox?: InfosBoxProps;
    // Greif Custom Code
    continueFormButton?: ButtonPresentationProps;
    formAction?: FormActionsProps;
}

export const contactFormStyles: ContactFormStyles = {
    container: {
        css: css`
            form {
                width: 100%;
            }
        `,
    },
    formGridItem: { width: 12 },
    successModal: { sizeVariant: "small" },
    successBox: {
        type: "success",
    },
};

// const styles = contactFormStyles; // Greif Custom Code
const emailsRegexp = new RegExp(
    "^[\\W]*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4}[\\W]*,{1}[\\W]*)*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4})[\\W]*$",
);

type Validator = () => boolean;
type ContextType = {
    validators: {
        [key: string]: Validator | undefined;
    };
};

export const ContactFormContext = React.createContext<ContextType>({
    validators: {},
});

const ContactForm = ({
    id,
    fields,
    submitContactForm,
    clearForm,
    validateReCaptcha,
    setFieldValue,
    // Greif Custom Code
    resetState,
    clearGreifForm,
    topic,
}: Props) => {
    const { emailRecipients, submitButtonText, successMessage } = fields;
    const [validators] = useState<{ [key: string]: Validator | undefined }>({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const recaptchaRef: RefObject<ReCAPTCHA> = React.createRef();

    /* Starter Custom Code - Start */
    const trackFormStart = ga.use.trackFormStart({ form_name: constants.contactUs.form_name });
    const trackFormSubmit = ga.use.trackFormSubmit({ form_name: constants.contactUs.form_name });
    const canTrackFormStartRef = useRef(true);
    const formRef = useRef<HTMLFormElement>(null);

    useEffect(() => {
        const handleFormFocus = () => {
            if (formRef.current?.contains(document.activeElement) && canTrackFormStartRef.current) {
                trackFormStart();
                canTrackFormStartRef.current = false;
            }
        };

        formRef.current?.addEventListener("focus", handleFormFocus, true);

        return () => {
            formRef.current?.removeEventListener("focus", handleFormFocus);
        };
    }, []);
    /* Starter Custom Code - End */

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const widgetValidators: Validator[] = [];
        Object.keys(validators).forEach(key => {
            const validator = validators[key];
            if (validator) {
                widgetValidators.push(validator);
            }
        });
        const results = widgetValidators.map(v => v());
        if (!results.every(o => o)) {
            return;
        }

        const isReCaptchaValid = await validateReCaptcha({ location: "ContactUs", recaptchaRef });

        if (!isReCaptchaValid) {
            return;
        }

        setIsSubmitting(true);
        submitContactForm({
            emailRecipients,
            onSuccess: () => {
                setIsModalOpen(true);
                setIsSubmitting(false);
                /* Starter Custom Code - Start */
                trackFormSubmit();
                canTrackFormStartRef.current = true;
                /* Starter Custom Code - End */
            },
            onComplete() {
                // "this" is targeting the object being created, not the parent SFC
                // eslint-disable-next-line react/no-this-in-sfc
                this.onSuccess?.();
            },
        });
    };

    const modalCloseHandler = () => {
        setIsModalOpen(false);
        clearForm();
        clearGreifForm(); // Greif Custom Code
        resetState();
    };

    /* Starter Removed - continueButtonClickHandler */

    /* Greif Custom Code - Start */
    const isAuthenticated = useIsAuthenticated();

    const styles = useMemo(() => {
        const styleToHide =
            !isAuthenticated && topicToHideFieldsArray.includes(topic || "") ? "submitButton" : "continueFormButton";
        return mergeProps<ContactFormStyles>(contactFormStyles, {
            [styleToHide]: {
                css: css`
                    display: none;
                `,
            },
            formAction: {
                extendedStyles: {
                    flexWrapper: {
                        wrapper:
                            !isAuthenticated && topicToHideFieldsArray.includes(topic || "")
                                ? {
                                      css: css`
                                          margin-top: 0;
                                          ${() => {
                                              if (typeof topic === "undefined" || topic === "") {
                                                  return "display: none;";
                                              }
                                          }}
                                      `,
                                  }
                                : undefined,
                        item:
                            !isAuthenticated && topicToHideFieldsArray.includes(topic || "")
                                ? {
                                      css: css`
                                          margin-left: 4px;
                                      `,
                                  }
                                : undefined,
                    },
                },
            },
        });
    }, [topic]);

    const continueButtomOnClick = () => {
        window.location.href = fields.continueLink;
    };
    /* Greif Custom Code - End */

    return (
        <FormWrapper /* Starter Custom Code */>
        <GridContainer {...styles.container}>
            <GridItem {...styles.formGridItem}>
                <ContactFormContext.Provider value={{ validators }}>
                    <form
                        id="contactForm"
                        onSubmit={handleFormSubmit}
                        noValidate
                        ref={formRef} // Starter Custom Code
                    >
                        <Zone contentId={id} zoneName="Content" />
                            <ReCaptcha recaptchaRef={recaptchaRef} location="ContactUs" />
                        {/* Starter Custom Code - Start */}
                        <FormActions {...styles.formAction} /* Greif Custom Code */>
                            <Button {...styles.submitButton} type="submit" disabled={isSubmitting}>
                                {submitButtonText}
                            </Button>
                            {/* Greif Custom Code - Start */}
                            <Button {...styles.continueFormButton} onClick={continueButtomOnClick}>
                                {translate("Continue")}
                            </Button>
                            {/* Greif Custom Code - End */}
                        </FormActions>
                        <Modal
                            headline={translate("Message Sent")}
                            contentLabel={successMessage}
                            {...styles.successModal}
                            isOpen={isModalOpen}
                            handleClose={modalCloseHandler}
                        >
                                <InfosBox {...styles.successBox}>{successMessage}</InfosBox>
                                <FormActions>
                                <Button {...styles.continueButton} onClick={modalCloseHandler}>
                                    {translate("Continue")}
                                </Button>
                            </FormActions>
                        </Modal>
                        {/* Starter Custom Code - End */}
                    </form>
                </ContactFormContext.Provider>
            </GridItem>
        </GridContainer>
        </FormWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ContactForm),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.emailRecipients,
                displayName: "Email recipients",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "testaccount@insitesoft.com",
                isRequired: true,
                regularExpression: emailsRegexp,
            },
            {
                name: fields.submitButtonText,
                displayName: "Submit Button Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Send",
            },
            {
                name: fields.successMessage,
                displayName: "Submit Success Message",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                defaultValue: "Thank you for your inquiry. A customer service representative will contact you shortly.",
            },
            // Greif Custom Code
            {
                name: fields.continueLink,
                displayName: "Continue Link",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "https://www.greif.com/contact/",
            },
        ],
    },
};

export default widgetModule;
